import { useState } from 'react';
import { faqs } from '@/mocks/entertainment';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 md:px-6 pt-16 md:pt-24">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <p className="text-xs font-bold tracking-widest text-primary-600 mb-2">FAQ</p>
        <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">常见问题</h3>
        <p className="mt-2 text-sm text-foreground-600">关于信息来源、热榜机制与投稿反馈，这里一次讲清楚。</p>
      </div>

      <div className="space-y-3">
        {faqs.map((f, i) => {
          const open = openIdx === i;
          return (
            <div
              key={f.q}
              className={`rounded-2xl border bg-background-50 transition ${
                open ? 'border-accent-300' : 'border-background-200/70 hover:border-background-300'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
                aria-expanded={open}
              >
                <span className="text-base font-bold text-foreground-950 flex items-center gap-3">
                  <span className="w-6 h-6 shrink-0 rounded-md bg-primary-100 text-primary-600 text-xs flex items-center justify-center font-black">Q{i + 1}</span>
                  {f.q}
                </span>
                <i className={`ri-add-line text-xl text-foreground-500 transition-transform duration-300 ${open ? 'rotate-45 text-primary-500' : ''}`}></i>
              </button>
              <div className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}